import React, { Component } from 'react';

import { LinkContainer } from 'react-router-bootstrap';
import Wrp from '../../../../hoc/Wrp/Wrp';

class ButtonList extends Component {
  
    componentDidMount(){
      // console.log(this.props);
    }

    callButtonListHtml = (buttonList) => {
      //console.log(buttonList, 'buttonList')
      if(buttonList!==null && buttonList.length>0){
        return buttonList.map((item, i) => {
          const eventsHandler = {
            onClick:() => (item.clickHandler) ?
            item.clickHandler(item,item.attributes):
                          'javascript(void)'
          }
          return(
            <Wrp key={"column"+item.attributes.id}>
              {(item.access_mode==true)? 
                <LinkContainer key={item.attributes.id} to={item.href} {...eventsHandler}>
                <a {...item.attributes} >
                  {item.value}
                </a>
                </LinkContainer>
              :''}
              
            </Wrp>
          )
        });
      }      
    }
     callButtonListTitle = (buttonList) => {
      //console.log(buttonList, 'buttonList')
      if(buttonList!==null && buttonList.length>0){
        let titleArr = [];
         buttonList.map((item, i) => {
         titleArr.push(item.value);
          
        });
         return titleArr.join(',')
      }      
    }

    render () {
      const {colData,id,header} = this.props;
      
      const access_mode = (colData.access_mode==undefined)? true:colData.access_mode;
      // console.log(colData);
      const href = (colData.href) ? colData.href:"#";
        return(
          <Wrp>
            <td className="" style={{"maxWidth":"200px"}} title={this.callButtonListTitle(this.props.colData)} >
                <div className="" >  
                  <div className="table_dots" style={{"width":"100%"}}>
                    {this.callButtonListHtml(this.props.colData)} 
                  </div> 
                </div>
            </td>
          </Wrp>                      
        );
    }
}

export default ButtonList;